import script from "./register-company-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./register-company-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__